import { Component, OnInit } from "@angular/core";
import { TasksService } from "./tasks.service";
import { Activity, EditActivity } from "./task";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material";
import { DeletePopUpComponent } from "../../common/delete-pop-up/delete-pop-up.component";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { SessionStorage } from "ngx-webstorage";
import { filter } from "rxjs/operators";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

@Component({
  selector: "app-tasks",
  templateUrl: "./tasks.component.html",
  styleUrls: ["./tasks.component.css"],
})
export class TasksComponent implements OnInit {
  @SessionStorage() public user;
  @SessionStorage() public userObj;
  @SessionStorage() public config;

  public tasklistarr: any = [];
  public originTaskList: any = [];
  public taskSearch: string = "";
  public flag: boolean = false;
  public addErrors: any;
  public pageNumber: number = 1;
  public totalElements: any = 0;

  constructor(
    public taskService: TasksService,
    public router: Router,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private spinnerService: Ng4LoadingSpinnerService
  ) {}

  ngOnInit() {
    this.getTaskLists();
  }

  /* function to get task list */
  getTaskLists() {
    this.tasklistarr = [];
    this.originTaskList = [];
    this.spinnerService.show();
    this.taskService.getTaskList(this.pageNumber).subscribe(
      (data) => {
        this.spinnerService.hide();
        this.totalElements = data.payload.totalactivities;
        data.payload.activities.forEach((value) => {
          this.tasklistarr.push(new Activity(value));
          this.originTaskList.push(new Activity(value));
        });
      },
      (error) => {
        this.spinnerService.hide();
      }
    );
  }

  /* function to check search data*/
  checkSearchData() {
    if (!this.taskSearch) {
      this.pageNumber = 1;
      this.getTaskLists();
    }
  }

  /* function to get search activity*/
  applySearch() {
    if (this.taskSearch) {
      this.spinnerService.show();
      this.taskService.searchFilter(this.taskSearch.trim()).subscribe(
        (response) => {
          this.spinnerService.hide();
          this.totalElements = response.payload.length;
          this.tasklistarr = response.payload.map((task) => new Activity(task));
        },
        (error) => {
          this.spinnerService.hide();
          this.tasklistarr = [];
          // this.snackBar.open('No Results found', 'OK', { duration: 3000 });
        }
      );
    }
  }

  /* function to open add task form and upload activity */
  addTask() {
    this.router.navigate(["/admin/tasks/add-task"]);
  }

  /* function to delete activity */
  deleteTask(task, flag) {
    if (!flag) {
      const dialogRef = this.dialog.open(DeletePopUpComponent);
      dialogRef.afterClosed().subscribe((result) => {
        if (result == true) {
          const data = {
            userObj: this.userObj,
          };
          this.taskService.deleteTask(task, data).subscribe(
            (response) => {
              this.snackBar.open("Activity deleted successfully", "OK", {
                duration: 3000,
              });
              this.getTaskLists();
            },
            (error) => {
              this.snackBar.open("Error Deleting Activity ", "OK", {
                duration: 3000,
              });
            }
          );
        }
      });
    }
  }

  /* function to update activity */
  updateTask(row, i) {
    this.tasklistarr[i].editMode = true;
    this.tasklistarr
      .filter((ele, j) => i != j)
      .map((ele) => (ele.editMode = false));
  }

  /* function to apply edit mode*/
  editMode(i, val) {
    if (this.tasklistarr[i].activityType) {
      this.addErrors = val;
      if (!val.errors) {
        this.addErrors = "";
        this.flag = false;
        // Check if same activity name already exists
        this.originTaskList
          .filter(
            (ele, j) =>
              i != j && ele.activityType == this.tasklistarr[i].activityType
          )
          .map((ele) => (this.flag = true));
        if (!this.flag) {
          this.tasklistarr[i].editMode = false;
          const data = new EditActivity(
            this.tasklistarr[i],
            this.originTaskList,
            this.userObj
          );
          this.taskService.updateTask(data).subscribe(
            (response) => {
              this.snackBar.open("Activity updated succcessfully", "OK", {
                duration: 3000,
              });
              this.getTaskLists();
            },
            (error) => {
              this.snackBar.open("Error Updating Activity ", "OK", {
                duration: 3000,
              });
            }
          );
        }
      }
    } else {
      this.snackBar.open("Please fill the Activity Details", "OK", {
        duration: 3000,
      });
    }
  }

  /* function to task list default */
  triggerChange(data: any) {
    this.pageNumber = data;
    if (!this.taskSearch) {
      this.getTaskLists();
    } else {
      this.applySearch();
    }
  }

  /* function to expand container */
  auto_grow(activityName) {
    if (activityName === true) {
      const activtyName = document.getElementById("actName");
      activtyName.style.overflow = "hidden";
      activtyName.style.height = "0px";
      activtyName.style.height = activtyName.scrollHeight + "px";
    } else {
      const description = document.getElementById("actDescription");
      description.style.overflow = "hidden";
      description.style.height = "0px";
      description.style.height = description.scrollHeight + "px";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/tasks/tasks.component.ts